import { SpeedBands } from "./types"

export const getSpeedingPercentage = (speedBands: SpeedBands | null) => {
  if (!speedBands) return null
  if (!Object.values(speedBands).every((it) => it !== null)) return null
  return (
    speedBands.criticalSpeedBandPercentage! +
    speedBands.majorSpeedBandPercentage! +
    speedBands.minorSpeedBandPercentage!
  )
}

export const getSpeedBands = (minor: number | null, major: number | null, critical: number | null): SpeedBands => ({
  minorSpeedBandPercentage: minor || 0,
  majorSpeedBandPercentage: major || 0,
  criticalSpeedBandPercentage: critical || 0,
})

export const setMaximumDecimalPlaces = (value: number, places: number): number => parseFloat(value.toFixed(places))
